import {BehaviorSubject, Observable, ReplaySubject, Subject} from "rxjs";
import {ItemEvent} from "../classes/ItemEvent";
import {ItemConfig} from "./ItemConfig";
import {appInjector} from "../classes/appInjector";
import {ServerConnectionService} from "../services/serverConnection/server-connection.service";
import {ConcreteHierarchyItemInterface} from "../classes/concreteLayers/ConcreteHierarchyItemInterface";
import {isRemoveSidebar} from "../../configs/view_only";

export class CadMarker {
  private _id:number;
  set id(value){
    this._id = value;
  }

  get id(){
    return this._id;
  }

  private _label: string;
  get label(){
    return this._label;
  }

  private _entityId: string;
  get entityId(){
    return this._entityId;
  }
  set entityId(value){
    this._entityId = value;
  }

  private _imgPosition = {left: null, top: null};
  set imgPosition(position){
    if (position && position.left !== null){
      this._imgPosition = position;
    }
  }
  get imgPosition(){
    return this._imgPosition;
  }

  private _normalizedPosition = {left: null, top: null};
  set normalizedPosition(position){
    if (position && position.left !== null){
      this._normalizedPosition = position;
    }
  }
  get normalizedPosition(){
    return this._normalizedPosition;
  }

  private _mapPosition = {latitude: null, longitude: null};
  set mapPosition(position){
    if (position){
      this._mapPosition = position;
    }
  }
  get mapPosition(){
    return this._mapPosition;
  }

  constructor(config) {
    this.assign(config);
  }

  private assign(config){
    this._imgPosition = (config.hasOwnProperty('imgPosition')) ? config.imgPosition : {left: null, top: null};
    this._mapPosition = (config.hasOwnProperty('mapPosition')) ? config.mapPosition : {latitude: null, longitude: null};
    this._id = (config.hasOwnProperty('id')) ? config.id : Math.random() * 100;
    this._label = (config.hasOwnProperty('label')) ? config.label : 'Marker '+this.id;
  }


}


